// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sending-message-btn {
  box-shadow: 0px 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0px 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
  padding: var(--xxs, 2px) var(--default, 8px);
  border: 2px solid transparent;
  background: var(--AA-global-white-bg);
  position: relative;
  background-clip: padding-box;
}
.sending-message-btn::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: inherit;
  background: var(--border-gradient, transparent);
  z-index: -1;
  pointer-events: none;
  transition: background 0.1s ease;
}
.sending-message-btn .aa-action-text {
  color: var(--AA-global-theme-text-color);
}
.sending-message-btn .aa-dynamic-send-close {
  border: 0px;
  background-color: transparent;
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/atom/dynamic-send-action-btn.scss"],"names":[],"mappings":"AAAE;EACI,8JAAA;EACA,4CAAA;EACA,6BAAA;EACA,qCAAA;EACA,kBAAA;EACA,4BAAA;AACN;AACM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,+CAAA;EACA,WAAA;EACA,oBAAA;EACA,gCAAA;AACR;AAEM;EACE,wCAAA;AAAR;AAGM;EACE,WAAA;EACA,6BAAA;EACA,YAAA;AADR","sourcesContent":["  .sending-message-btn{\n      box-shadow: 0px 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0px 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n      padding: var(--xxs, 2px) var(--default, 8px);\n      border: 2px solid transparent;\n      background: var(--AA-global-white-bg);\n      position: relative;\n      background-clip: padding-box;\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        border-radius: inherit;\n        background: var(--border-gradient, transparent);\n        z-index: -1;\n        pointer-events: none;\n        transition: background 0.1s ease;\n      }\n      \n      .aa-action-text{\n        color: var(--AA-global-theme-text-color);\n      }\n      \n      .aa-dynamic-send-close{\n        border: 0px;\n        background-color: transparent;\n        padding: 0px;\n      }\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
